exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quiz-timer-wrapper .quiz-timer[data-v-8dc52f38] {\n  display: flex;\n}\n.quiz-timer-wrapper .quiz-timer .time[data-v-8dc52f38] {\n  font-weight: bold;\n  color: #f35f5d;\n  padding-right: 10px;\n  display: flex;\n  align-items: center;\n}\n.quiz-timer-wrapper .quiz-timer .icon i[data-v-8dc52f38] {\n  font-size: 28px;\n}\n@media only screen and (max-width: 768px) {\n.quiz-timer-wrapper .quiz-timer .time[data-v-8dc52f38] {\n    order: 2;\n}\n.quiz-timer-wrapper .quiz-timer .icon[data-v-8dc52f38] {\n    order: 1;\n    margin-right: 5px;\n}\n}", ""]);

// exports
